export default __webpack_public_path__ + "static/media/reading-method.89356997.gif";